import { useQuery } from 'hooks/useCustomQuery';
import getTemplate from 'API/Templates/getTemplate';

const useGetTemplate = (templateId, enabled = true) => {
    return useQuery({
        queryKey: ['Template', templateId],
        queryFn: async () => {
            const response = await getTemplate(templateId);
            return response.data;
        },
        enabled: enabled && !!templateId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetTemplate;
